<div class="fx-ib-ranking card bg-dark-lighter text-white">
  <div class="card-body">
    <div class="row">
      <div class="col fs-16">
        <span class="">{{ "IB Ranking" }}</span>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <span class="text-info cursor-pointer" (click)="navigationToPointConversion()">
          Edit point conversion
        </span>
      </div>
      <div class="col-md-6">
        <button class="pull-right btn btn-main" (click)="setValueIBRanking()" data-bs-toggle="modal"
        data-bs-target="#modalIbRanking">
        Edit
      </button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 col-xs-12">
        <div class="table-responsive">
          <table class="rox-table table-bordered bg-dark">
            <thead>
              <tr>
                <th class="text-center" width="10%">No</th>
                <th class="text-center" >Rank Name </th>
                <th class="text-center" >Required point </th>
                <!-- <th class="text-center">Volume

                  <img src="assets/images/images/info.png" class="icon-info"
                    pTooltip="Total qualified volume from IB affiliate trader" tooltipStyleClass="alert-tooltip"
                    tooltipPosition="bottom">
                </th> -->
                <th class="text-center">IB Reward Level</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of listIbRanking;let i = index;">
                <td class="text-center">{{ i+1 }}</td>
                <td class="text-center">{{ item.name }}</td>
                <td class="text-center" *ngIf="item.name != 'Diamond'">{{ item.from }} - {{item.to}}</td>
                <td class="text-center" *ngIf="item.name == 'Diamond'">{{ item.from }}</td>
                <!-- <td class="text-center">{{ item.from }}~{{item.to}}</td> -->
                <td class="text-center">{{ item.rate }} %</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- CHANGE GROUP NAME MODAL -->
  <div class="modal fade fx-modal" id="modalIbRanking" #modalIBRanking>
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">IB Rewards settings</h4>
          <button type="button" class="close" data-bs-dismiss="modal" 
            (click)="closeEditIbRanking()">
            &times;
          </button>
          <br>
        </div>
        <!-- Modal body -->
        <form class="form form-horizontal" autocomplete="off" #form="ngForm" (submit)="onSubmitIbRanking()">
          <div class="mx-5 my-3 note">
            <div>The required point is determined within a range starting from the upper point of the previous level up to the defined value. In the case of Bronze, the required point begins from 0. For instance:</div> 
            <ul>
              <li>If the set value for Bronze is 10, the necessary point to achieve Bronze rank will range from 0 to 10.</li>
              <li>If the set value for Silver is 20, the required point to attain Silver rank will range from 10.01 to 20</li>
            </ul>
          </div>
        <div class="modal-body mb-3">
          <!-- <p class="text-center text-sm title">IB Reward Level should decrease from 100% to lower level to ensure positive IB Reward for IB level 0</p> -->
            <div class="row mb-3">
              <div class="col-lg col-12">
                <div class="row px-5" *ngFor="let level of arr; let i = index">
                  <div class="col-2">
                    <div class="label fs-16"> {{level.name}}</div>
                  </div>
                  <!-- <div class="col-4">
                    <div class="text-sm">From</div>
                    <div class="input-group dark">
                      <input class="form-control bg-dark" type="number" [disabled]="true" #from="ngModel" name="from_{{ i }}"
                        [(ngModel)]="level.from" />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="text-sm">To</div>
                    <div class="input-group dark">
                      <input class="form-control bg-dark" #to="ngModel" type="number" pattern="^\d*\.?\d+$" (blur)="onChangeValue(i)" name="to_{{ i }}"
                        [(ngModel)]="level.to" required  />

                    </div>
                    <div class="errors-group">
                      <small class="error-message" *ngIf="to.errors?.required && (to?.dirty || to?.touched || form?.submitted)">
                        Required
                      </small>
                      <small class="error-message"
                        *ngIf="!(arr[i]?.from <  this.arr[i]?.to) && to.valid">
                        Volume to is greater than level volume from
                      </small>
                      <small class="error-message" *ngIf="to.errors?.pattern">
                        wrong pattern
                      </small>
                    </div>
                  </div> -->
                  <div class="col-5 mb-2">
                    <div class="input-group dark">
                      <input class="form-control bg-dark" 
                        type="text" 
                        mask="0*.00"
                        (input)="onchangePoint($event)"
                        [dropSpecialCharacters]="false"
                        [(ngModel)]="level.point" 
                        #rate="ngModel"
                        required
                        maxlength="12"
                        [disabled]="level.name == 'Diamond'"
                        name="point{{ i }}" />
                      <span class="input-group-text">points</span>
                    </div>
                    <div class="col text-red" *ngIf="errorMessage[i]">
                      {{errorMessage[i]}}
                    </div>
                    <div class="errors-group" *ngIf="rate.errors">
                      <small class="error-message" *ngIf="rate.errors?.required">
                        {{'VALIDATIONS.REQUIRED' | translate}}
                      </small>
                    </div>
                  </div>
                  <div class="col-4 mb-2">
                    <div class="input-group dark">
                      <input class="form-control bg-dark" type="text" 
                        mask="0*.00"
                        (input)="onInput($event)"
                        [dropSpecialCharacters]="false"
                        [pTooltip]="'Max value : 100'"  [(ngModel)]="level.rate" #rate="ngModel"
                        name="rate_{{ i }}" />
                      <span class="input-group-text">%</span>
                    </div>
                  </div> 
                </div>
              </div>
            </div>
        </div>
        <div class="modal-footer">
          <button
            type="reset"
            class="mw-120 btn btn-transparent rounded"
            data-bs-dismiss="modal"
            (click)="closeEditIbRanking()"
          >
            Cancel
          </button>
          <button type="submit" class="btn btn-red rounded mw-120" >
            Save
          </button>
        </div>
      </form>
      </div>
    </div>
  </div>
</div>